import React from "react";

import "./left-arrow.m.css";

const LeftArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 13.826 22.406"
    className="left-arrow"
    styleName="left-arrow"
  >
    <path fill="#292929" d="M0 21.311L8.04 11.2 0 1.095 2.456 0l11.37 11.2-11.37 11.2z" data-name="Path 131744" />
  </svg>
);

export default LeftArrow;
